import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class CursoConstanciaApi {
    
    static activar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/cursoconstancia/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/cursoconstancia/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getCursoConstanciaList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/cursoconstancia?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    
    static getCursoConstancia(id, token ) {  
         return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/cursoconstancia/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(cursoconstancia, token ) {          
      let cursoconstanciaEnvio = Object.assign({}, cursoconstancia);
		let comando="POST";
		if (cursoconstanciaEnvio.id > 0) {
			comando="PUT";			
		} 
		cursoconstanciaEnvio=JSON.stringify(cursoconstanciaEnvio);
		return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/cursoconstancia/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: cursoconstanciaEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
    
    
    
    static saveImagenFondoImage(file, token ) {
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
            url: getLocacion()+ "/api/cursoconstancia/upload/foto",
            contentType: false,
            processData: false,
            type: 'POST',
            data: file,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    static saveImagenFirmaImage(file, token ) {
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
            url: getLocacion()+ "/api/cursoconstancia/upload/fotoFirma",
            contentType: false,
            processData: false,
            type: 'POST',
            data: file,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    
    static getCursoConstanciaCombo(token ) {

		return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/cursoconstancia/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}